export const MISSING_DATA = '';

export const DEFAULT_MAX_HEIGHT = 3;
export const DEFAULT_FLOOR_HEIGHT = 3;
export const MAX_COUNTER = 99;
export const BROADCAST_CHANNEL_NAME = 'zps-bc';
export const BROADCAST_LOGOUT_KEY = 'zps-bc-logout';

// Time interval constants in milliseconds for asset tracking
export const INTERVAL_TIME = {
  DEFAULT: 15 * 60 * 1000, // 15 minutes for equipment
  HAZARD: 30 * 1000, // 30 seconds for hazard areas
  WORKER: 2 * 60 * 1000, // 2 minutes for workers
};

export enum LS_KEYS {
  ACCOUNT_NAME = 'account_name',
  ACCOUNT_RES_NAME = 'account_res_name',
  BUILD_TIME = 'buildtime',
  CLIENT_ID = 'client_id',
  COGNITO = 'aws.cognito.identity',
  COLLAPSE = 'collapse',
  GLOBAL = 'global',
  IDENTITY_POOL_ID = 'identity_pool_id',
  IS_SHOW_INACTIVE = 'is_show_inactive',
  LOCATION = 'location',
  REGION = 'region',
  REMEMBER_ME = 'remember_me',
  SHOW_GRID = 'show-grid',
  TERM_OF_USE = 'term-of-use',
  UI = 'ui',
  UI_STORE = 'ui-settings',
  USER_DATA = 'user-data',
  USER_POOL_ID = 'user_pool_id',
  USERNAME = 'username',
  VIEW_ZONES = 'view-zones',
}

export enum PARAM_KEY {
  EQUIPMENT_ID = 'equipment-id',
  FIRM_EDIT_ID = 'firm-edit-id',
  GROUP_ID = 'group-id',
  SUBCONTRACTOR_ID = 'subcontractor-id',
  WORKER_EDIT_ID = 'worker-edit-id',
  WORKER_ID = 'worker-id',
  SITE_ID = 'site-id'
}

export enum QUERY_KEY {
  ACCOUNT_PERMISSIONS = 'account-permissions',
  ALERTS = 'alerts',
  ALL_SITES_MAPS = 'all-sites-maps',
  ANALYTICS_DWELL_TIMES = 'analytics-dwell-times',
  ANALYTICS_TRIPS = 'analytics-trips',
  ARCHIVE_ACTION = 'archive-action',
  ARCHIVED_ALERTS = 'archived-alerts',
  ASSETS = 'assets',
  ASSETS_CATEGORIES = 'assets-categories',
  ASSETS_DETAILS = 'assets-details',
  ASSETS_TAGS = 'assets-tags',
  ASSIGNED_PERMISSIONS = 'assigned-permissions',
  AUDIT_LOG = 'audit-log',
  CHECK_UPDATE = 'check-update',
  COMPANIES = 'companies',
  EMPLOYEES = 'employees',
  EQUIPMENT_CREATE = 'create-equipment',
  EQUIPMENT_DELETE = 'delete-equipment',
  EQUIPMENT_GET = 'get-equipment',
  EQUIPMENT_OCCUPANTS = 'equipment_occupants',
  EQUIPMENT_TAGS = 'equipment_tags',
  EQUIPMENT_UPDATE = 'update-equipment',
  EQUIPMENTS_GET = 'get-equipments',
  EXECUTE = 'execute',
  FLOORS = 'floors',
  GEOFENCE_CREATE = 'create-geofence',
  GEOFENCE_DELETE = 'delete-geofence',
  GEOFENCE_UPDATE = 'update-geofence',
  GEOFENCES_GET = 'get-geofences',
  GET_READERS = 'readers',
  LOCATION_HISTORY = 'location-history',
  LOGIN = 'login',
  MAPS = 'maps',
  METRICS = 'metrics',
  REFRESH_TOKEN = 'refresh-token',
  RESERVATION = 'reservation',
  RESERVATION_EVENT_SUBMIT = 'reservation_event_submit',
  RESERVATION_HISTORY = 'reservation-history',
  SET_ASSETS = 'set-assets',
  SITE_CALENDARS_GET = 'site-calendars-get',
  SITE_POLICIES_GET = 'site-policies-get',
  SITE_SHIFTS_GET = 'site-shifts-get',
  SITE_TAGS = 'site-tags',
  SITES = 'sites',
  TAG_DIAGNOSTICS = 'tag-diagnostics',
  TAG_DIAGNOSTICS_DOWNLOAD = 'download-tag-diagnostics',
  TAG_DIAGNOSTICS_LAST_LOCATION_HISTORY = 'last-location-history',
  TOGGLE_ASSET_STATUS = 'toggle-asset-status',
  TOGGLE_ASSET_STATUS_BATCH = 'toggle-asset-status-batch',
  TOGGLE_FIRM_STATUS = 'toggle-firm-status',
  TRACKERS_HISTORY = 'trackers-history',
  USER_POOL = 'user-pool',
  USER_SETTINGS_CREATE = 'user-settings-create',
  USER_SETTINGS_GET = 'user-settings-get',
  USER_SETTINGS_UPDATE = 'user-settings-update',
  WORKERS = 'workers',
  ZPS_USER = 'zps-user-detail',
  ZPS_USERS = 'zps-users',
}

export enum TEST_ID {
  ACCORDION_TITLE_ICON = 'title-icon',
  ACTIVE_ROUTE = 'active-route',
  NAVIGATE = 'navigate',
  OUTLET = 'outlet',
}

export enum URL_PARAMS {
  ACTIONS = 'view',
  ASSET = 'asset',
  ASSET_AVAILABILITY = 'availability',
  ASSET_RES_NAME = 'asset_res_name',
  ASSETIZED = 'assetized',
  ASSIGNED = 'assigned',
  COUNT = 'count',
  CURRENT_ZONE = 'currentZone',
  DATE = 'date',
  DAY = 'current_day',
  END_TIME = 'end_time',
  END_ZONE = 'endZone',
  EQUIPMENT_ID = 'equipment_id',
  EQUIPMENT_STATUS = 'equipment-status',
  EQUIPMENT_SUBTYPE = 'subtype',
  EQUIPMENT_TYPE = 'type',
  EXTRA_GROUP = 'extra-group',
  FIRM = 'firm',
  FIRM_EDIT_ID = 'firm_edit_id',
  GEOFENCE_RES_NAME = 'geofence_res_name',
  GROUP = 'group',
  GROUP_ID = 'group_id',
  HIGHLIGHTED = 'highlighted',
  IS_READY_TO_FETCH = 'is_ready_to_fetch',
  MODE = 'mode',
  MULTI_ASSETS = 'multi-asset',
  MULTI_DATE = 'multi-date',
  MULTI_ZONES = 'multi-zone',
  RESERVATION_STATUS = 'reservation-status',
  ROLE = 'role',
  SELECTED = 'selected',
  SIDEBAR = 'sidebar',
  START_TIME = 'start_time',
  START_ZONE = 'startZone',
  STATUS = 'status',
  STEP = 'step',
  SUBCONTRACTOR_ID = 'subcontractor_id',
  TAB = 'tab',
  TAG_ATTACHED = 'attached',
  TIMESTAMP = 'timestamp',
  TOKEN = 'token',
  UTILIZATION_DATE = 'utilization-date',
  WORKER_EDIT_ID = 'worker_edit_id',
  WORKER_ID = 'worker_id',
  WORKFLOW_STATE = 'workflowState',
  ZONE = 'zone',
}

export enum MAP_MODE {
  HISTORICAL = 'history',
  REALTIME = 'realtime',
}

export const REQUESTS_OPTIONS = {
  DELAY: 60,
  INTERVAL: 1000,
  LIMIT_PER_VIEW: 10,
  LIMIT_POINTS: 1000,
  LIMIT_REQUEST: 2,
  TIMEOUT: 5000,
};

export const PAGINATION = {
  PAGE_SIZE: 50,
};

export const SOCKET = {
  EVENT: {
    CLIENT_CLOSED: '[WS]: Disconnected from server',
    CLIENT_OPENED: '[WS]: Connected to server',
    CONNECTION_ERROR: '[WS]: Connection error',
    INTERNAL_SERVER_ERROR: 'Internal server error',
    ON_RECONNECT_STOP: '[WS]: Reconnect stopped',
    RECONNECT: '[WS]: Reconnecting to server',
    SHOULD_RECONNECT: '[WS]: Should reconnect',
  },
  MESSAGE: {
    ACTION: 'setFilterOptions',
    MESSAGE_TYPES: [
      'location-updates',
      'geomatch-updates',
      'alerts-equipment',
      'alerts-safety',
      'alerts-system',
      'alerts-zone',
      'site-updates',
    ],
  },
  OPTIONS: {
    HEARTBEAT_INTERVAL: 25000,
    HEARTBEAT_TIMEOUT: 600000,
    RECONNECT_ATTEMPTS: 10,
    RECONNECT_INTERVAL: 3000,
  },
};

export enum RESERVATIONS {
  approvedMgr = 'Approved-Mgr',
  approvedSub = 'Pending-Mgr',
  conflictedMgr = 'Conflict-Mgr',
  conflictedSub = 'Conflict-Sub',
  draftSub = 'New-Reservation',
  eventApproveConflictMgrEx = 'resolve-conflict-mgr-explicitly',
  eventApproveConflictSubEx = 'resolve-conflict-sub-explicitly',
  eventApprovedMgr = 'approved-mgr',
  eventApprovedSub = 'submit-mgr',
  eventConflictRejectMgr = 'rejected-conflict-mgr',
  eventConflictRejectSub = 'rejected-conflict-sub',
  eventNewFromRejectMgr = 'modify-mgr-reservation',
  eventNewFromRejectSub = 'modify-sub-reservation',
  eventPendingSub = 'submit-sub',
  eventRejectMgr = 'rejected-mgr',
  eventRejectSub = 'rejected-sub',
  eventResolveConflictMgr = 'resolve-conflict-mgr',
  eventResolveConflictSub = 'resolve-conflict-sub',
  eventResolveStagedConflictMgr = 'resolve-staged-conflict-mgr',
  eventResolveStagedConflictSub = 'resolve-staged-conflict-sub',
  eventStagedConflictRejectMgr = 'rejected-staged-mgr',
  eventStagedConflictRejectSub = 'rejected-staged-sub',
  eventSubmitToMgr = 'submit-mgr-directly',
  rejectedMgr = 'Rejected-Mgr',
  rejectedSub = 'Rejected-Sub',
  requestedSub = 'Pending-Sub',
  stagedConflictedMgr = 'Staged-Conflict-Mgr',
  stagedConflictedSub = 'Staged-Conflict-Sub',
  validateConflictMgr = 'validate-conflict-mgr',
  validateConflictSub = 'validate-conflict-sub',
}

export enum RESERVATION_STATES {
  APPROVED = 'approved',
  CONFLICTED = 'conflicted',
  DRAFT = 'draft',
  PENDING = 'pending',
  REJECTED = 'rejected',
  REQUESTED = 'requested',
  STAGED_CONFLICTED = 'stagedConflicted',
}

export enum RESERVATION_ACTIONS {
  APPROVE = 'approve',
  EDIT = 'edit',
  REJECT = 'reject',
}

export const RESERVATION_EVENTS = {
  MANAGER: {
    APPROVE: 'approved-mgr',
    REJECT: 'rejected-mgr',
    REJECT_CONFLICT: 'rejected-conflict-mgr',
    REJECT_CONFLICT_STAGED: 'rejected-staged-mgr',
    RESOLVE_CONFLICT: 'resolve-conflict-mgr',
    RESOLVE_CONFLICT_EXPLICITLY: 'resolve-conflict-mgr-explicitly',
    SUBMIT: 'submit-mgr-directly',
    VALIDATE_CONFLICT: 'validate-conflict-mgr',
  },
  SUBCONTRACTOR: {
    APPROVE: 'submit-mgr',
    REJECT: 'rejected-sub',
    REJECT_CONFLICT: 'rejected-conflict-sub',
    REJECT_CONFLICT_STAGED: 'rejected-staged-sub',
    RESOLVE_CONFLICT: 'resolve-conflict-sub',
    RESOLVE_CONFLICT_EXPLICITLY: 'resolve-conflict-sub-explicitly',
    SUBMIT: 'submit-sub',
    VALIDATE_CONFLICT: 'validate-conflict-sub',
  },
} as const;

export enum SIDEBAR_PARAMS {
  ACTIONS = 'actions',
  ADD_ZONE = 'add_zone',
  ALL = 'all',
  ARCHIVE = 'archive',
  ASSETS_TAB = 'assets',
  AUTO_APPROVAL = 'auto_approval',
  DEVICES_TAB = 'devices',
  /** @deprecated */
  EDIT = 'edit',
  EDIT_ZONE = 'edit_zone',
  EQUIPMENT = 'equipment',
  PROFILE = 'profile',
  RESERVATION = 'reservation',
  SAFETY = 'safety',
  SITE_HOURS = 'site_hours',
  SITE_MAP = 'site_map',
  SYSTEM = 'system',
  /** @deprecated */
  VIEW = 'view',
  ZONE = 'zone',
  ZONES_TAB = 'zones',
}
